import { ErrorPage } from '@common/pages/Error';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const ErrorController: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') ?? undefined;
  const error = searchParams.get('error');
  const errorObj = new Error(error ?? 'Unknown error');
  return <ErrorPage message={message} err={errorObj} />;
};
